import { cn } from '@/utils/cn';
import type { BadgeProps } from './Badge.types';
import styles from './Badge.module.scss';

export function Badge({
  variant = 'default',
  size = 'md',
  children,
  className,
  ...props
}: BadgeProps) {
  const badgeClasses = cn(
    styles.badge,
    styles[`badge--${variant}`],
    styles[`badge--${size}`],
    className
  );

  return (
    <span className={badgeClasses} {...props}>
      {children}
    </span>
  );
}

export default Badge;
